@if (showBackButton) {
  <div class="inner-navigation">
    <div class="back" (click)="navigateBack()">
      <p class="text-button-small">{{ 'fnol-request-details.back-button-text' | translate }}</p>
    </div>
  </div>
}

<div class="fnol-request-title">
  <div class="title">
    <h4>{{ 'fnol-request-details.notification-date' | translate: { date: (fnolRequest.notificationDate | date: 'dd.MM.yyyy') } }}</h4>
  </div>
</div>

<div class="details-part info">
  <div class="row">
    <div class="title">
      <p class="body-12">{{ 'fnol-request-details.status' | translate }}</p>
    </div>
    <div class="value">
      <p class="subtitle-14">{{ fnolRequest.processingStatusAgg }}</p>
    </div>
  </div>

  <div class="row">
    <div class="title">
      <p class="body-12">{{ 'fnol-request-details.pet-name' | translate }}</p>
    </div>
    <div class="value">
      <p class="subtitle-14">{{ fnolRequest.fnolPetName }}</p>
    </div>
  </div>

  <div class="row">
    <div class="title">
      <p class="body-12">{{ 'fnol-request-details.email' | translate }}</p>
    </div>
    <div class="value">
      <p class="subtitle-14">{{ fnolRequest.fnolEmail }}</p>
    </div>
  </div>

  <div class="row">
    <div class="title">
      <p class="body-12">{{ 'fnol-request-details.first-name' | translate }}</p>
    </div>
    <div class="value">
      <p class="subtitle-14">{{ fnolRequest.fnolFirstName }}</p>
    </div>
  </div>

  <div class="row">
    <div class="title">
      <p class="body-12">{{ 'fnol-request-details.last-name' | translate }}</p>
    </div>
    <div class="value">
      <p class="subtitle-14">{{ fnolRequest.fnolLastName }}</p>
    </div>
  </div>

  @if (fnolRequest.fnolPhoneNumber) {
    <div class="row">
      <div class="title">
        <p class="body-12">{{ 'fnol-request-details.phone-number' | translate }}</p>
      </div>
      <div class="value">
        <p class="subtitle-14">{{ fnolRequest.fnolPhoneNumber }}</p>
      </div>
    </div>
  }

  <div class="row diagnosis-container">
    <div class="title">
      <p class="body-12">{{ 'fnol-request-details.diagnosis' | translate }}</p>
    </div>

    <div class="value">
      @for (diagnose of fnolRequest.fnolDiagnoses; track diagnose) {
        <div class="diagnose">
          <p class="subtitle-14">{{ getTranslatedDiagnose(diagnose.id, diagnose.category) }}
          ({{ getTranslatedCategory(diagnose.category) }})</p>
        </div>
      }
    </div>
  </div>
</div>
